import { gql } from "graphql-request";
import type { TransportPricingModel } from "@brickme/project-core/src";

type GetPricingModelQuery = {
	readonly pricingModel: TransportPricingModel;
};

const getPricingModelQuery = gql`
	query getPricingModelQuery {
		pricingModel {
			numColoursPremiumThreshold
			numColoursPremium
			discountBrackets {
				baseplateSize
				minimumQuantity
				discount
			}
			basePlateSizePrices {
				size
				price {
					amount
					currencyCode
				}
			}
			priceOverrides {
				baseplateSize
				quantity
				amount
			}
		}
	}
`;

export type { GetPricingModelQuery };
export default getPricingModelQuery;
